module.exports = __webpack_public_path__ + "static/media/Fr.Binu.641b6d57.png";